/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_L4_NInputs */

const en_mk_sec_pg_l4_n = /** @type {(inputs: Mk_Sec_Pg_L4_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tools used, data read, and the rupiah cost — open to anyone entitled to see that issue.`)
};

const id_mk_sec_pg_l4_n = /** @type {(inputs: Mk_Sec_Pg_L4_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alat yang dipakai, data yang dibaca, dan biayanya dalam rupiah — bisa dibuka siapa pun yang berhak melihat issue itu.`)
};

/**
* | output |
* | --- |
* | "Tools used, data read, and the rupiah cost — open to anyone entitled to see that issue." |
*
* @param {Mk_Sec_Pg_L4_NInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_l4_n = /** @type {((inputs?: Mk_Sec_Pg_L4_NInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_L4_NInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_l4_n(inputs)
	return en_mk_sec_pg_l4_n(inputs)
});